import { RowEditAndDelete } from 'components/icons/RowEditAndDelete';

export const columnsDataVendas = [
	{
		Header: ' ',
		accessor: 'CheckBox',
		disableSortBy: true,
		type: 'checkBox',
		filter: false,
	},
	{
		Header: 'NF',
		accessor: 'nf',
		type: 'text',
		optional: true,
		filter: 'includesIgnoreCase',
	},
	{
		Header: 'Seq.',
		accessor: 'sequenciaNF',
		type: 'number',
		optional: true,
		filter: 'includesIgnoreCase',
		hover: 'Sequência da Nota Fiscal',
	},
	{
		Header: 'Data da NF',
		accessor: 'dataVenda',
		type: 'date',
		optional: true,
		filter: 'includesIgnoreCase',
	},
	{
		Header: 'Quantidade',
		accessor: 'quantidade',
		type: 'text',
		optional: true,
		filter: 'includesIgnoreCase',
	},
	{
		Header: 'Receita Bruta',
		accessor: 'receitaBruta',
		type: 'money',
		optional: true,
		filter: 'includesIgnoreCase',
	},
	{
		Header: 'Família',
		accessor: 'familia',
		type: 'nullableTag',
		optional: true,
		filter: 'includesIgnoreCase',
	},
	{
		Header: 'Subfamília',
		accessor: 'subFamilia',
		type: 'nullableTag',
		optional: true,
		filter: 'includesIgnoreCase',
	},
	{
		Header: 'Modelo',
		accessor: 'modelo',
		type: 'nullableTag',
		optional: true,
		filter: 'includesIgnoreCase',
	},
	{
		Header: 'Nome do Produto',
		accessor: 'nomeProduto',
		type: 'text',
		optional: true,
		filter: 'includesIgnoreCase',
	},
	{
		Header: 'Cód. Produto',
		accessor: 'codProduto',
		type: 'relation',
		optional: true,
		filter: 'includesIgnoreCase',
	},
	{
		Header: 'Mercado',
		accessor: 'mercado',
		type: 'nullableTag',
		optional: true,
		filter: 'includesIgnoreCase',
	},
	{
		Header: 'Canal de Venda',
		accessor: 'canalVenda',
		type: 'nullableTag',
		createable: true,
		filter: 'includesIgnoreCase',
	},
	{
		Header: 'Força de Venda',
		accessor: 'forcaVenda',
		type: 'nullableTag',
		createable: true,
		filter: 'includesIgnoreCase',
	},
	{
		Header: 'Zona de Venda',
		accessor: 'zonaVenda',
		type: 'nullableTag',
		filter: 'includesIgnoreCase',
	},
	{
		Header: 'Membro',
		accessor: 'membro',
		type: 'nullableTag',
		filter: 'includesIgnoreCase',
	},
	{
		Header: 'Razão Social',
		accessor: 'razaoSocial',
		type: 'nullableTag',
		optional: true,
		filter: 'includesIgnoreCase',
	},
	{
		Header: 'CNPJ / CPF / ID',
		accessor: 'cnpjCliente',
		type: 'nullableTag',
		optional: true,
		filter: 'includesIgnoreCase',
	},
	{
		Header: 'Razão Social Relacionado',
		accessor: 'clienteRelacionado',
		type: 'nullableTag',
		optional: true,
		filter: 'includesIgnoreCase',
	},
	{
		Header: 'CNPJ / CPF / ID Relacionado',
		accessor: 'cnpjClienteRelacionado',
		type: 'nullableTag',
		optional: true,
		filter: 'includesIgnoreCase',
	},
	{
		Header: 'Código do Pedido',
		accessor: 'codigoPedido',
		type: 'nullableTag',
		optional: true,
		filter: 'includesIgnoreCase',
	},
	{
		Header: 'Data Registro',
		accessor: 'dataRegistro',
		type: 'date',
		optional: true,
		filter: 'includesIgnoreCase',
	},
	{
		Header: 'Última Atualização',
		accessor: 'lastUpdate',
		type: 'date',
		optional: true,
		filter: 'includesIgnoreCase',
		importable: false,
	},
	{
		Header: 'Cód. Hierarquia',
		accessor: 'code',
		type: 'text',
		optional: true,
		filter: 'includesIgnoreCase',
		importable: false,
	},
	{
		Header: ' ',
		type: 'jsx',
		accessor: 'button',
		jsx: RowEditAndDelete,
		filter: false,
	},
];
